import ActionsForm from '@/shared/mixins/actionsForm'
import SubGroupDetail from '../SubGroupDetail/SubGroupDetail.vue'
import addGroup from './addGroup/addGroup.vue'
import ImageNotFound from '../../../../../../../../../../static/img/qma/semDados.svg'
import deleteQuestion from '../deleteQuestion/deleteQuestion.vue'
import { toast } from '@/shared/utils/UIHelper'
import Iconavaliacao from '../../../../../../../../../../static/img/qma/IconAvalicao.svg'
import IconCampoTexto from '../../../../../../../../../../static/img/qma/IconMetadado.svg'

export default {
  name: 'GroupDetail',
  props: ['templateid', 'dadosGrupo', 'equipamento'],
  components: {SubGroupDetail, addGroup, deleteQuestion},
  mixins: [ActionsForm],
  data () {
    return {
      imgAvalicao: Iconavaliacao,
      imgAnexo: IconCampoTexto,
      notFound: ImageNotFound,
      openSections: [],
      metadado: false,
      subGrupo: true,
      dadosGrupoLocal: [],
      preRequisito: false,
      subEtapa: false,
      Editar: false,
      dadosSubEtapa: [],
      subEtapaId: null,
      grupoId: null,
      voltaParaGrupo: false,
      etapaCriada: false,
      itensChecado: []
    }
  },
  watch: {
    dadosGrupo (value) {
      this.dadosGrupoLocal = value
      this.voltarParaGrupos()
    }
  },
  mounted () {
  },
  methods: {
    toggleSection (index, obj) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    },
    verificarAberturaAutomatica (id) {
      this.dadosGrupoLocal.forEach((data, index) => {
        if (data.novaEtapa === true && data.etapaId === id && !this.openSections.includes(index)) {
          this.grupoId = data.etapaId
          this.toggleSection(index)
        }
      })
    },
    SelecionarEtapa (etapaId) {
      this.Adicionar = !this.Adicionar

      var div = null

      div = document.getElementById(etapaId)

      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.CheckTodosItem(etapaId, false)
      } else {
        div.classList.add('clicked')
        this.CheckTodosItem(etapaId, true)
      }
    },
    CheckTodosItem (etapaId, value) {
      for (let i = 0; i < this.dadosGrupoLocal.length; i++) {
        if (this.dadosGrupoLocal[i].etapaId === etapaId) {
          this.dadosGrupoLocal[i].checkEtapa = value
          for (let j = 0; j < this.dadosGrupoLocal[i].subEtapas.length; j++) {
            this.SelecionarPergunta(this.dadosGrupoLocal[i].subEtapas[j], etapaId, value)
          }
        }
      }
    },
    SelecionarPergunta (id, etapaId, acaoParaTodos) {
      this.Adicionar = !this.Adicionar
      var div = null

      div = document.getElementById(id.etapaId)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona

      if (acaoParaTodos == null) {
        if (isClicked) {
          div.classList.remove('clicked')
          this.itensChecado = this.itensChecado.filter(item => !(item.etapaId === etapaId && item.subEtapaId === id.etapaId))
          this.CheckItem(id.etapaId, etapaId, false)
        } else {
          div.classList.add('clicked')
          this.CheckItem(id.etapaId, etapaId, true)
          if (this.itensChecado !== null && this.itensChecado !== undefined && this.itensChecado.length > 0) {
            let item = {
              etapaId: etapaId,
              subEtapaId: id.etapaId
            }
            this.itensChecado.push(item)
          } else {
            let item = {
              etapaId: etapaId,
              subEtapaId: id.etapaId
            }
            this.itensChecado[0] = item
          }
        }
      } else {
        if (acaoParaTodos === false) {
          div.classList.remove('clicked')
          this.CheckItem(id.etapaId, etapaId, false)
          this.itensChecado = this.itensChecado.filter(item => !(item.etapaId === etapaId && item.subEtapaId === id.etapaId))
        } else {
          div.classList.add('clicked')
          this.CheckItem(id.etapaId, etapaId, true)
          if (this.itensChecado !== null && this.itensChecado !== undefined && this.itensChecado.length > 0) {
            let item = {
              etapaExclusao: true,
              etapaId: etapaId,
              subEtapaId: id.etapaId
            }
            this.itensChecado.push(item)
          } else {
            let item = {
              etapaExclusao: true,
              etapaId: etapaId,
              subEtapaId: id.etapaId
            }
            this.itensChecado[0] = item
          }
        }
      }
    },
    CheckItem (id, etapaId, value) {
      for (let i = 0; i < this.dadosGrupoLocal.length; i++) {
        if (this.dadosGrupoLocal[i].etapaId === etapaId) {
          for (let j = 0; j < this.dadosGrupoLocal[i].subEtapas.length; j++) {
            if (this.dadosGrupoLocal[i].subEtapas[j].etapaId === id) {
              this.dadosGrupoLocal[i].subEtapas[j].checkTodosItens = value
            }
          }
        }
      }
    },
    abrirModalAddEtapa (id, novaEtapa, data) {
      this.subEtapa = false
      var proximoNivelEtapa = this.calcularProximoNivelPrioridadeEtapa()
      if (data !== undefined && data !== null) {
        this.Editar = true
        this.$refs.modalAddEtapa.popUptEditarEtapa(id, novaEtapa, data.nivelPrioridadeEtapa, data.descricaoEtapa)
      } else {
        this.Editar = false
        this.$refs.modalAddEtapa.popUptAddEtapa(null, false, null, null, proximoNivelEtapa)
      }
    },
    abrirModalAddASubEtapa (id, novaEtapa, data, tipometadado, itens) {
      this.grupoId = itens.etapaId
      this.subEtapa = true
      this.Editar = false
      var proximoNivel = this.calcularProximoNivelPrioridade(itens, tipometadado)
      if (data !== undefined && data !== null) {
        this.$refs.modalAddEtapa.popUptSubEditarEtapa(id, novaEtapa, data.nivelPrioridadeEtapa, data.descricaoEtapa, data.etapaId, true)
      } else {
        this.$refs.modalAddEtapa.popUptAddEtapa(id, novaEtapa, tipometadado, proximoNivel)
      }
    },
    calcularProximoNivelPrioridade (data, metadado) {
      // Verifica se os dados são válidos
      // if (data.subEtapas.length === 0 && metadado === true) {
      //   return 1.01 // Retorna 1.01 caso o formato dos dados seja inválido
      // }

      // if (data.subEtapas.length === 0 && metadado === false) {
      //   return 1 // Retorna 1.01 caso o formato dos dados seja inválido
      // }

      if (data.subEtapas.length === 0) {
        return 1 // Retorna 1.01 caso o formato dos dados seja inválido
      }
      // Encontrar o maior valor de nivelPrioridadeEtapa, considerando conversões para decimal ou inteiro
      const maiorNivelPrioridade = data.subEtapas.reduce((max, subEtapa) => {
        let nivelAtual = subEtapa.nivelPrioridadeEtapa

        // Verificar se nivelAtual é uma string antes de realizar as conversões
        if (typeof nivelAtual === 'string') {
          if (nivelAtual.includes('.')) {
            nivelAtual = parseFloat(nivelAtual)// Converte para decimal
          } else {
            nivelAtual = parseInt(nivelAtual, 10)// Converte para inteiro
          }
        }

        // Atualizar o maior nível de prioridade, ignorando valores inválidos
        if (nivelAtual !== null && nivelAtual !== undefined && nivelAtual > max) {
          return nivelAtual
        }

        return max
      }, -Infinity)

      // Define o nível base como 1 caso todos os valores sejam null ou inválidos
      const nivelBase = maiorNivelPrioridade === -Infinity ? 1 : maiorNivelPrioridade

      // Determina o incremento: 1 para inteiros, 0.01 para decimais
      const incremento = Number.isInteger(nivelBase) ? 1 : 0.01
      const novoNivelPrioridade = nivelBase + incremento

      // Retorna o novo nível de prioridade
      return novoNivelPrioridade
    },
    calcularProximoNivelPrioridadeEtapa () {
      // Verifica se os dados são válidos
      if (this.dadosGrupoLocal.length === 0) {
        return 1 // Retorna 1.01 caso o formato seja inválido
      }

      // Encontrar o maior valor de nivelPrioridadeEtapa, considerando conversões para decimal ou inteiro
      const maiorNivelPrioridade = this.dadosGrupoLocal.reduce((max, item) => {
        let nivelAtual = item.nivelPrioridadeEtapa

        // Verificar se nivelAtual é uma string antes de realizar as conversões
        if (typeof nivelAtual === 'string') {
          if (nivelAtual.includes('.')) {
            nivelAtual = parseFloat(nivelAtual) // Converte para decimal
          } else {
            nivelAtual = parseInt(nivelAtual, 10) // Converte para inteiro
          }
        }

        // Atualizar o maior nível de prioridade, ignorando valores inválidos
        if (nivelAtual !== null && nivelAtual !== undefined && nivelAtual > max) {
          return nivelAtual
        }

        return max
      }, -Infinity)

      // Define o nível base como 1 caso todos os valores sejam null ou inválidos
      const nivelBase = maiorNivelPrioridade === -Infinity ? 1 : maiorNivelPrioridade

      // Determina o incremento: 1 para inteiros, 0.01 para decimais
      const incremento = Number.isInteger(nivelBase) ? 1 : 0.01
      const novoNivelPrioridade = nivelBase + incremento

      // Retorna o novo nível de prioridade
      return novoNivelPrioridade
    },
    tabelaNovaEtapa (value) {
      if (this.dadosGrupoLocal !== null && this.dadosGrupoLocal !== undefined && this.dadosGrupoLocal.length > 0) {
        this.dadosGrupoLocal = [...this.dadosGrupoLocal, value]
      } else {
        this.dadosGrupoLocal = [value]
      }
    },
    tabelaEditaEtapa (value) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === value.etapaId) {
          this.dadosGrupoLocal[j].descricaoEtapa = value.etapa
          this.dadosGrupoLocal[j].nivelPrioridadeEtapa = value.nivelPrioridadeEtapa
        }
      }
    },
    tabelaSubEditaEtapa (value) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === value.etapaId) {
          for (let s = 0; s < this.dadosGrupoLocal[j].subEtapas.length; s++) {
            if (this.dadosGrupoLocal[j].subEtapas[s].etapaId === value.subEtapaId) {
              this.dadosGrupoLocal[j].subEtapas[s].descricaoEtapa = value.subEtapa
              this.dadosGrupoLocal[j].subEtapas[s].nivelPrioridadeEtapa = value.nivelPrioridadeEtapa
            }
          }
        }
      }
    },
    tabelaApagaEtapaEstatica (value) {
      for (let j = this.dadosGrupoLocal.length - 1; j >= 0; j--) {
        if (this.dadosGrupoLocal[j].etapaId === value) {
          this.$emit('removerEtapaEstatica', value)
          this.$emit('removerEtapaEquipamentoEstatica', value)
          this.dadosGrupoLocal.splice(j, 1)
        }
      }
    },
    novaSubEtapa (value) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === value.etapaId) {
          this.dadosGrupoLocal[j].subEtapas = [...this.dadosGrupoLocal[j].subEtapas, value.subEtapa]
          this.verificarAberturaAutomatica(value.etapaId)
        }
      }
    },
    NovaPerguntaGrupo (value) {
      this.verificaEtapaNova(value)
      this.verificaSubEtapaNova(value)
    },
    abrirSubEtapa (sub, etapaId, etapaAdicao, metadado) {
      this.alteraFlagExpandir(sub, etapaId)
      this.etapaCriada = etapaAdicao
      this.metadado = metadado
      this.dadosSubEtapa = [sub]
      this.grupoId = etapaId
      this.voltaParaGrupo = true
      this.$emit('voltaParaGrupo', this.voltaParaGrupo)
    },
    alteraFlagExpandir (sub, etapa) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === etapa) {
          for (let s = 0; s < this.dadosGrupoLocal[j].subEtapas.length; s++) {
            if (this.dadosGrupoLocal[j].subEtapas[s].etapaId === sub.etapaId) {
              this.dadosGrupoLocal[j].subEtapas[s].expandir = !sub.expandir
            }
          }
        }
      }
    },
    voltarParaGrupos () {
      this.dadosSubEtapa = []
      this.voltaParaGrupo = false
      this.$emit('voltaParaGrupo', this.voltaParaGrupo)
    },
    addNovaEtapa (value) {
      this.$emit('addNovaEtapa', value)
    },
    editarEtapa (value) {
      this.$emit('editarEtapa', value)
    },
    editaSubEtapa (value) {
      this.$emit('editaSubEtapa', value)
    },
    addNovaSubEtapa (value) {
      this.$emit('addNovaSubEtapa', value)
    },
    addNovaSubEtapaObjSemNovaEtapa (value) {
      this.$emit('addNovaSubEtapaObjSemNovaEtapa', value)
    },
    addNovaPerguntaParaSubEtapa (value) {
      this.$emit('addNovaPerguntaParaSubEtapa', value)
    },
    addNovaPerguntaEtapaSubCriada (value) {
      this.$emit('addNovaPerguntaEtapaSubCriada', value)
    },
    ExcluirPerguntaPerguntaEquipamentoCriado (value) {
      this.$emit('ExcluirPerguntaPerguntaEquipamentoCriado', value)
    },
    ExcluirPerguntaTemplateDetalheCriado (value) {
      this.$emit('ExcluirPerguntaTemplateDetalheCriado', value)
    },
    ExcluirPerguntaEquipamento (value) {
      this.$emit('ExcluirPerguntaEquipamento', value)
    },
    ExcluirPerguntaTemplateDetalheSubEtapa (value) {
      this.$emit('ExcluirPerguntaTemplateDetalheSubEtapa', value)
    },
    RemoverEdicaoExcluirPerguntaEquipamento (value) {
      this.$emit('RemoverEdicaoExcluirPerguntaEquipamento', value)
    },
    RemoverEdicaoExcluirPerguntaTemplate (value) {
      this.$emit('RemoverEdicaoExcluirPerguntaTemplate', value)
    },
    ExcluirPerguntaTemplateDetalheEtapa (value) {
      this.$emit('ExcluirPerguntaTemplateDetalheEtapa', value)
    },
    ExcluirPerguntaTemplate (value) {
      this.$emit('ExcluirPerguntaTemplate', value)
    },
    addNovaPerguntaImagem (value) {
      this.$emit('addNovaPerguntaImagem', value)
    },
    EditarNovaPerguntaImagem (value) {
      this.$emit('EditarNovaPerguntaImagem', value)
    },
    verificaEtapaNova (value) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === value.etapaId) {
          if (this.dadosGrupoLocal[j].novaEtapa === true) {
            for (let e = 0; e < this.dadosGrupoLocal[j].subEtapas.length; e++) {
              if (this.dadosGrupoLocal[j].subEtapas[e].etapaId === value.subEtapaId) {
                if (this.dadosGrupoLocal[j].subEtapas[e].adicao === true) {
                  let novoGrupo = {
                    etapa: this.dadosGrupoLocal[j].descricaoEtapa,
                    etapaId: this.dadosGrupoLocal[j].etapaId,
                    subEtapas: [
                      {
                        subetapa: this.dadosGrupoLocal[j].subEtapas[e].descricaoEtapa,
                        subEtapaId: this.dadosGrupoLocal[j].subEtapas[e].etapaId,
                        itens: [{
                          pergunta: value.pergunta,
                          perguntaId: value.perguntaId,
                          tipoCampo: value.tipoCampo,
                          multiplos: value.multiplos,
                          temporarioId: value.temporarioId,
                          perguntaSelecao: value.perguntaSelecao,
                          nivelPrioridadePergunta: value.nivelPrioridadePergunta
                        }]
                      }
                    ]
                  }
                  this.$emit('novaEtapaEquipamentoPergunta', novoGrupo)
                  this.$emit('novaEtapaTemplatePergunta', novoGrupo)
                }
              }
            }
          }
        }
      }
    },
    verificaSubEtapaNova (value) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === value.etapaId) {
          if (this.dadosGrupoLocal[j].novaEtapa === false) {
            for (let e = 0; e < this.dadosGrupoLocal[j].subEtapas.length; e++) {
              if (this.dadosGrupoLocal[j].subEtapas[e].etapaId === value.subEtapaId) {
                if (this.dadosGrupoLocal[j].subEtapas[e].adicao === true) {
                  this.$emit('addNovaPerguntaParaSubEtapa', value)
                }
              }
            }
          }
        }
      }
    },
    popUpExcluirEquipamento () {
      if (this.itensChecado !== undefined) {
        if (this.itensChecado.length > 0) {
          this.$refs.modal_Excluir_Grupo.popUptAdd()
        }
      }

      if (this.$refs.subGroup !== undefined) {
        for (let i = 0; i < this.$refs.subGroup.length; i++) {
          var abrirpopUp = this.$refs.subGroup[i].temItenschecado()
          if (abrirpopUp) {
            this.$refs.subGroup[0].popUpExcluirEquipamento()
          }
        }
      }
    },
    deleteItensSubGrupo () {
      if (this.itensChecado.length > 0) {
        let itensARemover = []
        // Itera sobre os itens checados
        for (let i = 0; i < this.itensChecado.length; i++) {
          let checado = this.itensChecado[i]
          // Itera sobre os grupos de dados
          for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
            let grupo = this.dadosGrupoLocal[j]
            if (grupo.etapaId === checado.etapaId) {
              // Itera sobre as subetapas dentro do grupo
              for (let k = 0; k < grupo.subEtapas.length; k++) {
                let subEtapa = grupo.subEtapas[k]
                if (subEtapa.etapaId === checado.subEtapaId) {
                  subEtapa.checkTodosItens = false
                  subEtapa.edicao = true
                  subEtapa.descricaoEdicao = 'AG. ENVIO EXCLUSÃO'
                  subEtapa.colorStatus = 'rgb(255, 205, 205)'
                  subEtapa.colorFonte = 'rgb(136, 22, 22)'
                  subEtapa.exclusao = true
                  // Itera sobre os itens dentro da subEtapa
                  for (let l = 0; l < subEtapa.itens.length; l++) {
                    let item = subEtapa.itens[l]
                    item.exclusaoEtapa = true
                    item.edicao = true
                    item.descricaoEdicao = 'AG. ENVIO EXCLUSÃO'
                    item.check = false
                    item.colorStatus = 'rgb(255, 205, 205)'
                    item.colorFonte = 'rgb(136, 22, 22)'
                    item.exclusao = true
                  }
                  // Remove a classe 'clicked' da subEtapa se existir
                  let divSubEtapa = document.getElementById(checado.subEtapaId)
                  if (divSubEtapa && divSubEtapa.classList.contains('clicked')) {
                    divSubEtapa.classList.remove('clicked')
                  }
                  toast.info('Sucesso! Ag. Envio da Exclusão')
                  // Adiciona o checado para remover depois
                  itensARemover.push(checado)
                  let value = {
                    excluirEtapa: this.itensChecado[i].etapaExclusao,
                    subEtapaId: this.itensChecado[i].subEtapaId,
                    etapaId: this.itensChecado[i].etapaId
                  }
                  this.$emit('ExcluirSubEtapasEtapas', value)
                  this.$emit('ExcluirSubEtapasEtapasTemplateDetalhe', value)
                }
              }
              grupo.checkEtapa = false
              // Remove a classe 'clicked' do grupo se existir
              let divGrupo = document.getElementById(checado.etapaId)
              if (divGrupo && divGrupo.classList.contains('clicked')) {
                divGrupo.classList.remove('clicked')
              }
            }
          }
        }
        // Remove os itens que foram marcados para remoção
        this.itensChecado = this.itensChecado.filter(item => !itensARemover.includes(item))
      } else {
        toast.warning('Não há items selecionados para exclusão')
      }
    },
    RemoverEdicao (etapaId, subEtapaId) {
      for (let j = 0; j < this.dadosGrupoLocal.length; j++) {
        if (this.dadosGrupoLocal[j].etapaId === etapaId) {
          for (let e = 0; e < this.dadosGrupoLocal[j].subEtapas.length; e++) {
            const subEtapa = this.dadosGrupoLocal[j].subEtapas[e]
            // Verificar se é a subetapa correta e se não está marcada como adição
            if (subEtapa.etapaId === subEtapaId && subEtapa.adicao === false) {
              subEtapa.exclusao = false
              subEtapa.edicao = false
              subEtapa.descricaoEdicao = ''
              subEtapa.colorStatus = ''
              subEtapa.colorFonte = ''
              // Resetar todas as propriedades dos itens dentro da subetapa
              for (let p = 0; p < subEtapa.itens.length; p++) {
                const item = subEtapa.itens[p]
                item.exclusaoEtapa = false
                item.edicao = false
                item.descricaoEdicao = ''
                item.colorStatus = ''
                item.colorFonte = ''
                item.exclusao = false
              }
              toast.success('Edição removida com sucesso!')
              let value = {
                subEtapaId: subEtapaId,
                etapaId: etapaId
              }
              this.$emit('removerExclusaoEtapaSubEtapaEquipamento', value)
              this.$emit('removerExclusaoEtapaSubEtapa', value)
            }
            // Verificar se é uma subetapa que foi adicionada e removê-la
            if (subEtapa.etapaId === subEtapaId && subEtapa.adicao === true) {
              let value = {
                subEtapaId: subEtapaId,
                etapaId: etapaId
              }
              this.dadosGrupoLocal[j].subEtapas.splice(e, 1)
              toast.success('Item removido com sucesso!')
              e-- // Ajustar o índice após a remoção para evitar problemas de iteração
              this.$emit('removerSubEtapaEtapaCriada', value)
              this.$emit('removerSubEtapaAgEnvioEtapa', value)
            }
          }
        }
      }
    },
    EditaEquipamentoPergunta (value) {
      this.$emit('EditaEquipamentoPergunta', value)
    },
    editarEmMemoriaNovaPerguntaEtapaSubCriada (value) {
      this.$emit('editarEmMemoriaNovaPerguntaEtapaSubCriada', value)
    },
    editarEmMemoriaNovaPerguntaParaSubEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaSubEtapa', value)
    },
    editarEmMemoriaNovaPerguntaParaEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaEtapa', value)
    },
    EditaTemplateNovaPergunta (value) {
      this.$emit('EditaTemplateNovaPergunta', value)
    },
    EditaTemplatePergunta (value) {
      this.$emit('EditaTemplatePergunta', value)
    },
    removerImagemNova (value) {
      this.$emit('removerImagemNova', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/GroupDetail/GroupDetail.js